module.exports = __webpack_public_path__ + "61c5899c9e24202c70ebd0838b5517f1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/Bernadette.jpg
// module id = 554
// module chunks = 0